import { render, staticRenderFns } from "./ModalAddBotao.vue?vue&type=template&id=2c495ff1&scoped=true&"
import script from "./ModalAddBotao.vue?vue&type=script&lang=js&"
export * from "./ModalAddBotao.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddBotao.vue?vue&type=style&index=0&id=2c495ff1&prod&lang=css&"
import style1 from "./ModalAddBotao.vue?vue&type=style&index=1&id=2c495ff1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c495ff1",
  null
  
)

export default component.exports